// Summary Redux Types
export const GET_BOARD_REPORTS_REQUEST = "GET_BOARD_REPORTS_REQUEST";
export const GET_BOARD_REPORTS_SUCCESS = "GET_BOARD_REPORTS_SUCCESS";
export const GET_BOARD_REPORTS_FAIL = "GET_BOARD_REPORTS_FAIL";

export const GET_BOARD_MINI_SUMMARY_REQUEST = "GET_BOARD_MINI_SUMMARY_REQUEST";
export const GET_BOARD_MINI_SUMMARY_SUCCESS = "GET_BOARD_MINI_SUMMARY_SUCCESS";
export const GET_BOARD_MINI_SUMMARY_FAIL = "GET_BOARD_MINI_SUMMARY_FAIL";

export const GET_BOARD_MEMBER_WORKLOAD_REQUEST = "GET_BOARD_MEMBER_WORKLOAD_REQUEST";
export const GET_BOARD_MEMBER_WORKLOAD_SUCCESS = "GET_BOARD_MEMBER_WORKLOAD_SUCCESS";
export const GET_BOARD_MEMBER_WORKLOAD_FAIL = "GET_BOARD_MEMBER_WORKLOAD_FAIL";

export const GET_BOARD_MEMBER_WORKLOAD_WEEKLY_REQUEST = "GET_BOARD_MEMBER_WORKLOAD_WEEKLY_REQUEST";
export const GET_BOARD_MEMBER_WORKLOAD_WEEKLY_SUCCESS = "GET_BOARD_MEMBER_WORKLOAD_WEEKLY_SUCCESS";
export const GET_BOARD_MEMBER_WORKLOAD_WEEKLY_FAIL = "GET_BOARD_MEMBER_WORKLOAD_WEEKLY_FAIL";
